import { useState } from "react";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { currencyFormat } from "../../../helpers/numericFields";
import styles from './PaymentSchemeSummaryDetails.module.css'
import s from "react-multiple-select-dropdown-lite";
import { Link } from "react-router-dom";

export const PaymentSchemeSummaryDetails = ({ groupFile }) => {
  const { paymentSchemeSummary } = useSelector((state) => state.groupFiles);
  
  const sortedSchema = [...paymentSchemeSummary].sort(
  (a, b) => b.paymentDelayPercentage - a.paymentDelayPercentage
);

  return (
    <div style={{ marginTop: 20, marginBottom: 50, border: "1 solid gray", background: "white", padding: 20 }}>
      <div className="table-responsive">
        <Table className="table border text-nowrap mg-b-0 table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th># Expediente</th>
              <th>Cliente</th>
              <th>Total</th>
              <th>Pagado</th>
              <th>Pagos programados</th>
              <th>Retraso</th>
              <th>Retraso Meses</th>
              <th>Estatus</th>
            </tr>
          </thead>
          <tbody>
            {
              sortedSchema.map((scheme, index) => (
                <tr key={scheme.idIndividualFile}>
                  <td>{index + 1}</td>
                  <td><OverlayTrigger placement="top" overlay={<Tooltip >Ver Expediente</Tooltip>}>
                    <Link to={`/panel/expedienteIndividual?id=${scheme.idIndividualFile}`} className="btn btn-primary btn-sm rounded-11 me-2" ><span className="fs-15 fw-semibold text-center">{scheme.idIndividualFile}</span></Link>
                  </OverlayTrigger>
                  </td>
                  <td>{scheme.customer}</td>
                  <td>{currencyFormat(scheme.totalAmount)}</td>
                  <td>{currencyFormat(scheme.paid)}</td>
                  <td>{currencyFormat(scheme.nextPaymentsAmount)}</td>
                  <td>{currencyFormat(scheme.paymentDelayAmount)}
                     {scheme.paymentDelayAmount > 0 ? ` ( ${Math.round(scheme.paymentDelayPercentage)} % )` : ''}</td>
                  <td className="text-center">{scheme.paymentDelayMonths}</td>
                  <td className="text-center">
                    <i className={`fa fa-circle`} 
                      style={{fontSize:18, 
                        color: (scheme.severity === "None" ? "green" :
                          scheme.severity === "Mild" ? "lightgreen" :
                          scheme.severity === "Moderate" ? "orange" : 
                          scheme.severity === "Severe" ? "red" : "gray")}}></i>
                  </td>
                </tr>))
            }
          </tbody>
        </Table>
      </div>
    </div>
  )
}
